import { render, staticRenderFns } from "./audio-text.vue?vue&type=template&id=bd218c8a&scoped=true&"
import script from "./audio-text.vue?vue&type=script&lang=ts&"
export * from "./audio-text.vue?vue&type=script&lang=ts&"
import style0 from "./audio-text.vue?vue&type=style&index=0&id=bd218c8a&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd218c8a",
  null
  
)

export default component.exports